export const ProgressCircleConfig = {
  circleSizes: {
    xxs: {
      size: 32,
      radius: 12,
      strokeWidth: 3,
      textSize: "text-xs",
      center: 16,
    },
    xs2: {
      size: 48,
      radius: 18,
      strokeWidth: 4,
      textSize: "text-xs",
      center: 24,
    },
    xs: {
      size: 64,
      radius: 24,
      strokeWidth: 6,
      textSize: "text-xs",
      center: 32,
    },
    sm: {
      size: 96,
      radius: 36,
      strokeWidth: 8,
      textSize: "text-sm",
      center: 48,
    },
    md: {
      size: 144,
      radius: 54,
      strokeWidth: 12,
      textSize: "text-xl",
      center: 72,
    },
    lg: {
      size: 192,
      radius: 72,
      strokeWidth: 16,
      textSize: "text-2xl",
      center: 96,
    },
    xl: {
      size: 288,
      radius: 120,
      strokeWidth: 30,
      textSize: "text-5xl",
      center: 144,
    },
  },
  ratios: {
    radiusRatio: 0.417,
    strokeWidthRatio: 0.104,
    centerRatio: 0.5,
  },
};
